const colorInterpolation = (color1: string, color2: string, factor: number):string => {
  // Utiliser une expression régulière pour extraire les composantes RGB
  const regex = /\w\w/g

  // Vérifier si le match n'est pas null pour color1 et color2
  const color1Match = color1.match(regex)
  const color2Match = color2.match(regex)

  if (!color1Match || !color2Match) {
    throw new Error('Invalid color format')
  }

  // Convertir les composantes hexadécimales en nombres
  const color1RGB = color1Match.map((hex) => parseInt(hex, 16))
  const color2RGB = color2Match.map((hex) => parseInt(hex, 16))

  // Calculer l'interpolation
  const result = color1RGB.map((component, index) => {
    return Math.round(component + factor * (color2RGB[index] - component))
  })

  // Reconstruire la couleur interpolée
  return `rgb(${result[0]}, ${result[1]}, ${result[2]})`
}

const interpolateColor = () => {
    return colorInterpolation
}

export default interpolateColor
